export default function Menu(){

    /*---------------------/ 1 - Const - Variables /-------------------*/
    const topBar = document.getElementById('topBar');
    const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    const navbarCollapse = document.querySelector('.navbar-collapse');
    const body = document.body;
    let lastScrollTop = 0;
    const SHOW_THRESHOLD = 80; // Show top bar when scrolling back to 80px from top
    const topBarHeight = topBar.offsetHeight; // Store the original height
    let burgerTimeline;

    // FAB Variables
    const fabButton = document.getElementById('fabButton');
    const fabContainer = document.querySelector('.fab-container');
    const fabMenu = document.querySelector('.fab-menu');
    const fabOverlay = document.querySelector('.fab-overlay');
    const fabOptions = document.querySelectorAll('.fab-option');
    let fabTimeline;
    let isFabOpen = false;

    /*---------------------/ 2 - Functions /-------------------*/
    function initBurgerAnimation() {
        // Register GSAP plugin
        if (typeof gsap !== 'undefined' && gsap.registerPlugin) {
            gsap.registerPlugin(DrawSVGPlugin);

            // Create timeline with default settings
            burgerTimeline = gsap.timeline({
                defaults: { ease: "power2.inOut" },
                paused: true
            });

            // Set initial states
            gsap.set("#theBurger", { autoAlpha: 1 });
            gsap.set(".buns", { drawSVG: "0% 30%" });

            // Create animation sequence
            burgerTimeline.to(".patty", { duration: 0.35, drawSVG: "50% 50%" }, 0);
            burgerTimeline.to(".patty", { duration: 0.1, opacity: 0, ease: "none" }, 0.25);
            burgerTimeline.to(".buns", { duration: 0.85, drawSVG: "69% 96.5%" }, 0);
        }
    }

    function updateMobileMenuPosition() {
        if (navbarCollapse) {
            const hasHiddenTopBar = topBar.classList.contains('hide-top-bar');
            if (hasHiddenTopBar) {
                navbarCollapse.classList.add('mobile-menu-top-hidden');
            } else {
                navbarCollapse.classList.remove('mobile-menu-top-hidden');
            }
        }
    }

    function animateMenuIcon(isOpen) {
        if (burgerTimeline) {
            if (isOpen) {
                burgerTimeline.play();
            } else {
                burgerTimeline.reverse();
            }
        }
    }

    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const isScrollingDown = scrollTop > lastScrollTop;

        // Only update lastScrollTop if we're not at the threshold
        if (scrollTop > SHOW_THRESHOLD) {
            lastScrollTop = scrollTop;
        }

        if (isScrollingDown && scrollTop > topBarHeight) {
            // Scrolling down and past the top bar
            topBar.classList.add('hide-top-bar');
        } else if (!isScrollingDown && scrollTop <= SHOW_THRESHOLD) {
            // Scrolling up and reached threshold
            topBar.classList.remove('hide-top-bar');
        }

        // Update mobile menu position after topBar class changes
        updateMobileMenuPosition();
    }

    function toggleMobileMenu() {
        const isOpen = navbarCollapse.classList.contains('mobile-menu-open');

        if (isOpen) {
            // Close menu
            navbarCollapse.classList.remove('mobile-menu-open');
            body.classList.remove('mobile-menu-active');
            mobileMenuToggle.classList.remove('menu-open');
            animateMenuIcon(false);
        } else {
            // Open menu
            navbarCollapse.classList.add('mobile-menu-open');
            body.classList.add('mobile-menu-active');
            mobileMenuToggle.classList.add('menu-open');
            animateMenuIcon(true);
            // Update position when opening menu
            updateMobileMenuPosition();
        }
    }

    function closeMobileMenu() {
        navbarCollapse.classList.remove('mobile-menu-open');
        body.classList.remove('mobile-menu-active');
        mobileMenuToggle.classList.remove('menu-open');
        animateMenuIcon(false);
    }

    // FAB Functions
    function initFabAnimation() {
        if (typeof gsap !== 'undefined' && fabContainer) {
            // Create timeline for FAB animations
            fabTimeline = gsap.timeline({ paused: true });

            // Set initial states
            gsap.set(fabMenu, { autoAlpha: 0, scale: 0, transformOrigin: "bottom left" });
            gsap.set('.fab-menu-item', { x: -20, autoAlpha: 0 });
            gsap.set(fabOverlay, { autoAlpha: 0 });
            gsap.set('.fab-icon-back', { autoAlpha: 0, scale: 0 });
            gsap.set('.fab-icon-plus', { autoAlpha: 1, scale: 1 });

            // Animation sequence for opening
            fabTimeline.to(fabOverlay, { duration: 0.3, autoAlpha: 0.5 }, 0)
                      .to(fabMenu, { duration: 0.4, autoAlpha: 1, scale: 1, ease: "back.out(1.7)" }, 0.1)
                      .to('.fab-menu-item', { duration: 0.3, x: 0, autoAlpha: 1, stagger: 0.1, ease: "power2.out" }, 0.2)
                      .to('.fab-icon-plus', { duration: 0.2, autoAlpha: 0, scale: 0 }, 0)
                      .to('.fab-icon-back', { duration: 0.2, autoAlpha: 1, scale: 1 }, 0.1);
        }
    }

    function toggleFab() {
        if (!fabTimeline) return;

        if (isFabOpen) {
            // Close FAB
            fabTimeline.reverse();
            fabButton.classList.remove('fab-open');
            body.classList.remove('fab-active');
            isFabOpen = false;
        } else {
            // Open FAB
            fabTimeline.play();
            fabButton.classList.add('fab-open');
            body.classList.add('fab-active');
            isFabOpen = true;
        }
    }

    function closeFab() {
        if (isFabOpen && fabTimeline) {
            fabTimeline.reverse();
            fabButton.classList.remove('fab-open');
            body.classList.remove('fab-active');
            isFabOpen = false;
        }
    }

    function handleFabOptionClick(e) {
        const option = e.currentTarget.dataset.option;

        // Close FAB after selection
        closeFab();
    }

    /*---------------------/ 3 - Events /-------------------*/
    window.addEventListener('scroll', handleScroll);

    // Mobile menu toggle
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', toggleMobileMenu);
    }

    // Close menu when clicking on links
    const mobileNavLinks = navbarCollapse.querySelectorAll('.nav-link:not(.dropdown-toggle)');
    mobileNavLinks.forEach(link => {
        link.addEventListener('click', closeMobileMenu);
    });

    // Handle dropdown items separately (close menu when clicking dropdown items)
    const dropdownItems = navbarCollapse.querySelectorAll('.dropdown-item');
    dropdownItems.forEach(item => {
        item.addEventListener('click', closeMobileMenu);
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
        if (navbarCollapse.classList.contains('mobile-menu-open') &&
            !navbarCollapse.contains(e.target) &&
            !mobileMenuToggle.contains(e.target)) {
            closeMobileMenu();
        }
    });

    // FAB Events
    if (fabButton) {
        fabButton.addEventListener('click', toggleFab);
    }

    // FAB option clicks
    fabOptions.forEach(option => {
        option.addEventListener('click', handleFabOptionClick);
    });

    // Close FAB when clicking overlay
    if (fabOverlay) {
        fabOverlay.addEventListener('click', closeFab);
    }

    // Close FAB when clicking outside
    document.addEventListener('click', (e) => {
        if (isFabOpen && fabContainer &&
            !fabContainer.contains(e.target)) {
            closeFab();
        }
    });

    // Initialize burger animation when DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
        initBurgerAnimation();
        initFabAnimation();
    });

    // If DOM is already loaded, initialize immediately
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBurgerAnimation);
        document.addEventListener('DOMContentLoaded', initFabAnimation);
    } else {
        initBurgerAnimation();
        initFabAnimation();
    }

    // Initial position update
    updateMobileMenuPosition();
}
